import {
  iconPropTypes,
  iconDefaultProps,
  iconCommonProps
} from '../propTypes';

const NextTrackRounded = ({ className, color }) => (
  <svg
    { ...iconCommonProps }
    className={ className }
    fill='none'
    viewBox='0 0 49 25'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M23.684 14.362 4.04 24.412C2.444 25.23 0 24.438 0 22.419V2.321C0 .51 2.271-.582 4.04.326l19.644 10.046c1.752.894 1.758 3.096 0 3.99Z'
      fill={ color }
    />
    <path
      d='M41.684 14.362 22.04 24.412c-1.596.817-4.04.025-4.04-1.994V2.321C18 .51 20.271-.582 22.04.326l19.644 10.046c1.752.894 1.758 3.096 0 3.99Z'
      fill={ color }
    />
    <rect
      fill={ color }
      height={ 24.727 }
      rx={ 3 }
      width={ 6.182 }
      x={ 42.818 }
    />
  </svg>
);

NextTrackRounded.propTypes = { ...iconPropTypes };

NextTrackRounded.defaultProps = { ...iconDefaultProps };

export default NextTrackRounded;